import Modal from 'react-bootstrap/Modal';
import {Button} from "react-bootstrap";
import React from "react";
export function StreamDialog(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.data.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/*<iframe scrolling={'no'} src={props.data.streamUrl}/>*/}

                <div style={{textAlign:"center"}}><img className={"stream-img"} src={props.data.stream} alt={""}/></div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}